import React, { useEffect, useRef, useState } from 'react'
import { Button, CardMedia, Divider, Grid, Stack, Typography, useMediaQuery } from '@mui/material'
import ImgTrainingbanner from "../../../assets/Image/ImgProduct/Training-bg.png";
import { FnBlock_UI } from 'service/SystemFunction/SystemFunction';
import AOS from "aos";
import { Link, useLocation, useNavigate, useParams } from 'react-router-dom';
import { AxiosGet, ResultAPI } from 'service/CommonFunction/TS_function';
import { i18n } from 'i18n';
import parse from 'html-react-parser';
import ModelTrainingOutlinedIcon from '@mui/icons-material/ModelTrainingOutlined';
import { currentLanguage } from 'service/CommonFunction/AxiosConfig';

const i18nField = 'entities.PublicProductService.fields';


const DetailTraining = () => {


    const { BlockUI, UnBlockUI } = FnBlock_UI();
    const Layout900 = useMediaQuery('(min-width:900px)');

    const navigate = useNavigate();
    const location = useLocation();

    const [objDetailOnsite, setobjDetailOnsite] = useState(null)

    useEffect(() => {
        const queryString = location.search;
        const urlParams = new URLSearchParams(queryString);
        const sID = urlParams.get("sID");
        if (sID != null && sID != "") {
            GetTrainingByID(sID);
        }
    }, [])

    const GetTrainingByID = (sID) => {
        BlockUI()
        AxiosGet(`Training/GetTrainingByID`, { "sTrainingID": sID, "sLanguage": currentLanguage() }, (res) => {
            UnBlockUI();
            ResultAPI(res, null, () => {
                let result = res?.result;
                if (result) {
                    window.scrollTo({
                        top: 0,
                        left: 0,
                        behavior: "smooth",
                    });
                    setobjDetailOnsite(result)
                }
            })
        });
    }

    const options = {
        replace: (domNode) => {
            if (domNode.attribs && domNode.attribs.class === 'remove') {
                return <></>;
            }
        },
    };

    return (
        <>
            <div style={{ position: 'relative' }}>
                <div style={{ position: 'absolute', top: !Layout900 ? '50%' : '40%', left: '10%' }}>
                    <Typography style={{ lineHeight: "1", color: '#ffffff' }}>
                        <span style={{ fontWeight: "400", display: "flex", fontSize: !Layout900 ? "1.4em" : "3em" }}>
                            Onsite Training
                        </span>
                        <Grid container spacing={2} direction="row" justifyContent="start" alignItems="center">
                            <Grid item>
                                <Link to="/Home" preventScrollReset={true}>
                                    <span style={{ fontWeight: "400", color: '#ffffff', fontSize: !Layout900 ? "0.8em" : "1em" }}>
                                        {i18n(`${i18nField}.sHomepage`)}
                                    </span>
                                </Link>
                            </Grid>
                            <Grid item>
                                <Divider orientation='vertical' style={{ height: '30px', backgroundColor: '#ffffff' }} />
                            </Grid>
                            <Grid item>
                                <span style={{ fontWeight: "400", fontSize: !Layout900 ? "0.8em" : "1em" }}>
                                    <b>  {i18n(`${i18nField}.sVOC2`)}</b>
                                </span>
                            </Grid>
                        </Grid>
                    </Typography>
                </div>
                <img src={ImgTrainingbanner} alt='' style={{ width: '100%', minHeight: '250px', objectFit: 'cover' }} />
            </div>
            <div className='box-detail-train' style={!Layout900 ? { padding: '2em' } : {}}>
                <Grid container spacing={2} direction="row" justifyContent="center" alignItems="start" >
                    <Grid item xs={12} sm={9}>
                        <img src={objDetailOnsite?.sFileLink} alt='' className='training-img' />
                    </Grid>
                    <Grid item xs={12} sm={9} style={{ marginTop: '-130px' }}>
                        <div className='training-detail-box'>
                            <Grid container spacing={2} direction="row" justifyContent="center" alignItems="start" >
                                <Grid item xs={12} style={{ borderBottom: '1px solid rgba(97,97,97,.8)' }}>
                                    <Grid container spacing={2} direction="row" justifyContent="space-between" alignItems="start" style={{paddingBottom:'1em'}}>
                                        <Grid item>
                                            <Typography className='title-intro-product' style={{ fontSize: '1.5em', fontWeight: 500 }}>
                                                {objDetailOnsite?.sTrainingName}
                                            </Typography>
                                        </Grid>
                                        <Grid item>
                                            <Button
                                                variant="outlined"
                                                size="large"
                                                style={{ backgroundColor: '#d32f2f', border: 'none', color: '#ffffff', borderRadius: '25px', padding: '4px 16px' }}
                                                startIcon={<ModelTrainingOutlinedIcon style={{ color: '#ffffff' }} />}
                                                onClick={() => {
                                                    let StrUrl = "/Front/PublicProductAndServiceForm?sID=" + objDetailOnsite?.sTrainingID;
                                                    navigate(StrUrl,
                                                        {
                                                            state:
                                                            {
                                                                sTypeID: "3", //1 = Product, 2 = Service, 3 = Training
                                                            }
                                                        })
                                                }}
                                            >
                                                {i18n(`${i18nField}.sInterestedTraining`)}
                                            </Button>
                                        </Grid>
                                    </Grid>
                                </Grid>
                                <Grid item xs={12} >
                                    {
                                        objDetailOnsite?.lstContent != null && objDetailOnsite?.lstContent.length > 0
                                            ?
                                            <>
                                                {
                                                    objDetailOnsite?.lstContent.map((itemContent, ind) => {
                                                        if (itemContent.nTypeID == 1) {
                                                            // sTypeText : "ข้อความ"
                                                            return (
                                                                <div key={`prd-sv${ind}`} data-aos="fade-up" data-aos-duration="1500">
                                                                    <Grid container spacing={1} direction="row" justifyContent="start">
                                                                        <Grid item xs={12} >
                                                                            {parse(itemContent?.sContent, options)}
                                                                        </Grid>
                                                                    </Grid>
                                                                </div>
                                                            )
                                                        }
                                                        else if (itemContent.nTypeID == 2) {
                                                            // sTypeText : "รูปภาพ"
                                                            return (
                                                                <div key={`prd-sv${ind}`} data-aos="fade-up" data-aos-duration="1500">
                                                                    <Grid container spacing={1} direction="row" justifyContent="start">
                                                                        <Grid item xs={12} >
                                                                            {/* <img src={itemContent?.sContent ?? ""} alt={""} style={{ width: '100%', height: 'auto', objectFit: 'cover' }} /> */}
                                                                            <CardMedia
                                                                                component={"img"}
                                                                                sx={{
                                                                                    objectFit: "contain",
                                                                                    width: "90%",
                                                                                    maxWidth: "100%",
                                                                                    maxHeight: "calc(90vh - 45px)",
                                                                                    cursor: "pointer",
                                                                                }}
                                                                                src={itemContent?.sImageOrVideo}
                                                                                alt={itemContent?.sImageAlt}
                                                                            />
                                                                            <Typography variant="body1" style={{ marginTop: '1em', fontWeight: 300 }}>
                                                                                {itemContent?.sContent ?? ""}
                                                                            </Typography>
                                                                        </Grid>
                                                                    </Grid>
                                                                </div>
                                                            )
                                                        }
                                                        else if (itemContent.nTypeID == 3) {
                                                            // sTypeText : "video"
                                                            return (
                                                                <div key={`prd-sv${ind}`} data-aos="fade-up" data-aos-duration="1500">
                                                                    <Grid container spacing={1} direction="row" justifyContent="start">
                                                                        <Grid item xs={12} >
                                                                            <CardMedia
                                                                                className='youtube-style'
                                                                                component="video"
                                                                                controls
                                                                                height="400px"
                                                                                src={itemContent.sImageOrVideo}
                                                                            />
                                                                        </Grid>
                                                                    </Grid>
                                                                </div>
                                                            )
                                                        }
                                                        else if (itemContent.nTypeID == 4) {
                                                            // sTypeText : "รูปภาพ"
                                                            return (
                                                                <div key={`prd-sv${ind}`} data-aos="fade-up" data-aos-duration="1500">
                                                                    <Grid container spacing={1} direction="row" justifyContent="start">
                                                                        <Grid item xs={12} >
                                                                            <CardMedia
                                                                                className='youtube-style'
                                                                                component="iframe"
                                                                                allow={"accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"}
                                                                                allowFullScreen
                                                                                frameBorder={0}
                                                                                src={(itemContent?.sUrl || "").split("/")[(itemContent?.sUrl || "").split("/").length - 1] != -1
                                                                                    ? `https://www.youtube.com/embed/${(itemContent?.sUrl || "").split("/")[(itemContent?.sUrl || "").split("/").length - 1].split("=", (itemContent?.sUrl || "").split("/")[(itemContent?.sUrl || "").split("/").length - 1].length)[1]}`
                                                                                    : `https://www.youtube.com/embed/${(itemContent?.sUrl || "").split("/")[(itemContent?.sUrl || "").split("/").length - 1]}`}
                                                                            />
                                                                            <Typography variant="body1" style={{ marginTop: '1em', fontWeight: 300 }}>
                                                                                {itemContent?.sContent ?? ""}
                                                                            </Typography>
                                                                        </Grid>
                                                                    </Grid>
                                                                </div>
                                                            )
                                                        }
                                                    })
                                                }
                                            </>
                                            :
                                            null
                                    }
                                </Grid>
                            </Grid>
                        </div>
                    </Grid>
                </Grid>
            </div>

        </>
    )
}

export default DetailTraining